const CompanyInfoSection = () => {
  const companyInfo = [
    { label: '医院名', value: 'おかやま整形外科' },
    { label: '電話番号', value: '086-012-3456' },
    { label: '所在地', value: '〒700-0000 岡山市北区○○町1-2-3' },
    { label: '専門分野', value: '整形外科、リハビリテーション科' },
  ];

  return (
    <>
      <section className="py-20 lg:py-32 bg-white px-6">
        <div className="max-w-5xl mx-auto">
          <div className="bg-gray-50 rounded-3xl p-8 lg:p-16 shadow-lg">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-12">
              基本情報
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
              {/* 写真 */}
              <div className="w-full h-[400px] rounded-2xl overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/4ac4a0bb1715094adfa2b103f20ed4fd.jpeg" 
                  alt="おかやま整形外科" 
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* 基本情報 */}
              <div className="space-y-0">
                {companyInfo.map((item, index) => (
                  <div
                    key={index}
                    className="grid grid-cols-1 md:grid-cols-3 gap-4 py-4 border-b border-gray-200 last:border-b-0"
                  >
                    <div className="font-semibold text-gray-700">
                      {item.label}
                    </div>
                    <div className="md:col-span-2 text-gray-900">
                      {item.value}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 lg:py-32 bg-gray-50 px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-12">診療時間</h2>
          
          <div className="overflow-x-auto">
            <div className="bg-white rounded-3xl shadow-lg overflow-hidden min-w-[640px]">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-[#007bbb]">
                    <th className="text-center py-5 px-4 text-white font-bold text-lg border-r border-white">診療時間</th>
                    <th className="text-center py-5 px-4 text-white font-bold text-lg border-r border-white">月</th>
                    <th className="text-center py-5 px-4 text-white font-bold text-lg border-r border-white">火</th>
                    <th className="text-center py-5 px-4 text-white font-bold text-lg border-r border-white">水</th>
                    <th className="text-center py-5 px-4 text-white font-bold text-lg border-r border-white">木</th>
                    <th className="text-center py-5 px-4 text-white font-bold text-lg border-r border-white">金</th>
                    <th className="text-center py-5 px-4 text-white font-bold text-lg border-r border-white">土</th>
                    <th className="text-center py-5 px-4 text-white font-bold text-lg">日</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-200">
                    <td className="py-6 px-4 text-center font-semibold text-gray-900 bg-gray-50 border-r border-gray-200">9:00～12:30</td>
                    <td className="py-6 px-4 text-center border-r border-gray-200">
                      <div className="w-8 h-8 flex items-center justify-center mx-auto bg-gray-900 rounded-full">
                        <div className="w-4 h-4 bg-gray-900 rounded-full"></div>
                      </div>
                    </td>
                    <td className="py-6 px-4 text-center border-r border-gray-200">
                      <div className="w-8 h-8 flex items-center justify-center mx-auto bg-gray-900 rounded-full">
                        <div className="w-4 h-4 bg-gray-900 rounded-full"></div>
                      </div>
                    </td>
                    <td className="py-6 px-4 text-center border-r border-gray-200">
                      <div className="w-8 h-8 flex items-center justify-center mx-auto">
                        <div className="w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-b-[14px] border-b-gray-900"></div>
                      </div>
                    </td>
                    <td className="py-6 px-4 text-center border-r border-gray-200">
                      <div className="w-8 h-8 flex items-center justify-center mx-auto bg-gray-900 rounded-full">
                        <div className="w-4 h-4 bg-gray-900 rounded-full"></div>
                      </div>
                    </td>
                    <td className="py-6 px-4 text-center border-r border-gray-200">
                      <div className="w-8 h-8 flex items-center justify-center mx-auto bg-gray-900 rounded-full">
                        <div className="w-4 h-4 bg-gray-900 rounded-full"></div>
                      </div>
                    </td>
                    <td className="py-6 px-4 text-center border-r border-gray-200">
                      <div className="w-8 h-8 flex items-center justify-center mx-auto">
                        <div className="w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-b-[14px] border-b-gray-900"></div>
                      </div>
                    </td>
                    <td className="py-6 px-4 text-center">
                      <div className="w-8 h-8 flex items-center justify-center mx-auto">
                        <span className="text-2xl font-bold text-gray-900">×</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="py-6 px-4 text-center font-semibold text-gray-900 bg-gray-50 border-r border-gray-200">14:30～18:30</td>
                    <td className="py-6 px-4 text-center border-r border-gray-200">
                      <div className="w-8 h-8 flex items-center justify-center mx-auto bg-gray-900 rounded-full">
                        <div className="w-4 h-4 bg-gray-900 rounded-full"></div>
                      </div>
                    </td>
                    <td className="py-6 px-4 text-center border-r border-gray-200">
                      <div className="w-8 h-8 flex items-center justify-center mx-auto bg-gray-900 rounded-full">
                        <div className="w-4 h-4 bg-gray-900 rounded-full"></div>
                      </div>
                    </td>
                    <td className="py-6 px-4 text-center border-r border-gray-200">
                      <div className="w-8 h-8 flex items-center justify-center mx-auto">
                        <span className="text-2xl font-bold text-gray-900">×</span>
                      </div>
                    </td>
                    <td className="py-6 px-4 text-center border-r border-gray-200">
                      <div className="w-8 h-8 flex items-center justify-center mx-auto bg-gray-900 rounded-full">
                        <div className="w-4 h-4 bg-gray-900 rounded-full"></div>
                      </div>
                    </td>
                    <td className="py-6 px-4 text-center border-r border-gray-200">
                      <div className="w-8 h-8 flex items-center justify-center mx-auto bg-gray-900 rounded-full">
                        <div className="w-4 h-4 bg-gray-900 rounded-full"></div>
                      </div>
                    </td>
                    <td className="py-6 px-4 text-center border-r border-gray-200">
                      <div className="w-8 h-8 flex items-center justify-center mx-auto">
                        <span className="text-2xl font-bold text-gray-900">×</span>
                      </div>
                    </td>
                    <td className="py-6 px-4 text-center">
                      <div className="w-8 h-8 flex items-center justify-center mx-auto">
                        <span className="text-2xl font-bold text-gray-900">×</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="bg-white px-8 py-6 text-sm text-gray-700 space-y-2">
                <p><span className="inline-block w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-b-[10px] border-b-gray-900 mr-2 align-middle"></span>:水・土曜の午前・・・9:00～13:00</p>
                <p><span className="text-xl font-bold mr-2">×</span>:休診・・・水・土曜の午後、日曜、祝日</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CompanyInfoSection;